/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListAgentPolicyGrantsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListAgentPolicyGrantsRequest = {
  /**
   * First-class agent identifier
   */
  agentId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListAgentPolicyGrantsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAgentPolicyGrantsSecurity$outboundSchema: z.ZodMiniType<
  ListAgentPolicyGrantsSecurity$Outbound,
  ListAgentPolicyGrantsSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAgentPolicyGrantsSecurityToJSON(
  listAgentPolicyGrantsSecurity: ListAgentPolicyGrantsSecurity,
): string {
  return JSON.stringify(
    ListAgentPolicyGrantsSecurity$outboundSchema.parse(
      listAgentPolicyGrantsSecurity,
    ),
  );
}

/** @internal */
export type ListAgentPolicyGrantsRequest$Outbound = {
  agent_id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAgentPolicyGrantsRequest$outboundSchema: z.ZodMiniType<
  ListAgentPolicyGrantsRequest$Outbound,
  ListAgentPolicyGrantsRequest
> = z.pipe(
  z.object({
    agentId: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      agentId: "agent_id",
      gramSession: "Gram-Session",
    });
  }),
);

export function listAgentPolicyGrantsRequestToJSON(
  listAgentPolicyGrantsRequest: ListAgentPolicyGrantsRequest,
): string {
  return JSON.stringify(
    ListAgentPolicyGrantsRequest$outboundSchema.parse(
      listAgentPolicyGrantsRequest,
    ),
  );
}
